import styled from "styled-components";

export const FooterContainer = styled.div`
width: 100%;
padding: 1.5rem 0;

`;

export const Autor = styled.h2`
    font-size: 18px;
    color: #FFF;
`;